import { useCallback, useEffect, useState } from 'react'
import {
    readTaskFilterState,
    type TaskFilterState,
    writeTaskFilterState,
} from '../utils/taskFilters'

export function useTaskFilters(projectId: string | undefined) {
    const [selectedAssigneeIds, setSelectedAssigneeIds] = useState<string[]>([])
    const [isTaskFiltersOpen, setIsTaskFiltersOpen] = useState(false)
    const [taskFilterState, setTaskFilterState] = useState<TaskFilterState>(() => (
        readTaskFilterState(projectId)
    ))

    useEffect(() => {
        setTaskFilterState(readTaskFilterState(projectId))
        setSelectedAssigneeIds([])
        setIsTaskFiltersOpen(false)
    }, [projectId])

    const updateSelectedAssigneeIds = useCallback((selectedIds: string[]) => {
        setSelectedAssigneeIds(selectedIds)
    }, [])

    const removeUnavailableAssignees = useCallback((availableIds: string[]) => {
        const availableIdSet = new Set(availableIds)
        setSelectedAssigneeIds((currentIds) => (
            currentIds.every((id) => availableIdSet.has(id))
                ? currentIds
                : currentIds.filter((id) => availableIdSet.has(id))
        ))
    }, [])

    const updateTaskFilters = useCallback((nextState: TaskFilterState) => {
        setTaskFilterState(nextState)
        writeTaskFilterState(projectId, nextState)
    }, [projectId])

    return {
        isTaskFiltersOpen,
        removeUnavailableAssignees,
        selectedAssigneeIds,
        setIsTaskFiltersOpen,
        taskFilterState,
        updateSelectedAssigneeIds,
        updateTaskFilters,
    }
}
